define('v3/Common/Models/enums',['lodash'], function (_) {
	var enums = {
		countryCodes: {
			Nl: 1,
			It: 2,
			Es: 3,
			Fr: 4,
			De: 5,
			Uk: 6,
			Be: 7,
			Ch: 8,
			Us: 10
		},

		countryCodeNameMap: {
			1: 'Nl',
			2: 'It',
			3: 'Es',
			4: 'Fr',
			5: 'De',
			6: 'Uk',
			7: 'Be',
			8: 'Ch',
			10: 'Us'
		},

		languageBasedHelpPages: {
			Es: 'https://colegios.snappet.org/soporte-2/'
		},

		slideMenuState: {
			collapsed: 0,
			showExercises: 1,
			showBottomButtons: 2
		},

		mainMenuArea: {
			home: 'Home',
			lessons: 'Lessons',
			workingsets: 'WorkingSets',
			monitor: 'Monitor',
			reports: 'Reports'
		},

		leftMenuStateEnum: {
			hidden: 0,
			hiddenOpenDropdown: 1,
			narrow: 2,
			narrowTunedWide: 3,
			wide: 4,
			wideTunedNarrow: 5
		},

		orientation: {
			landscape: 1,
			portrait: 2
		},

		adaptiveScreenNavigationMode: {
			normal: 0,
			skipped: 1,
			wrong: 2
		},

		answerType: {
			noAnswer: null,
			error: 0,
			eventuallyRight: 1,
			correctFirstTime: 2,
			madeNotChecked: 3,
			skipped: 4
		},
		progressTableMode: {
			pupils: 0,
			learningObjectives: 1
		},
		displaySize: {
			desktop: 0,
			mobile: 1
		},
		sortOrder: {
			answersDesc: 0,
			starsAsc: 1,
			starsDesc: 2
		},
		sortDirection: {
			ascending: 'asc',
			descending: 'desc'
		},
		filterMode: {
			all: 0,
			good: 1,
			unknown: 2,
			bad: 3,
			focus: 4
		},
		searchCategory: {
			lessons: 1,
			learningObjectives: 2
		},

		subjectCategoryValue: {
			ArithmeticNetherlands: 1,
			MathematicsNetherlands: 2,
			ArithmeticSpain: 5,
			ArithmeticBelgium: 6,
			SpellingNetherlands: 12,
			TaalNetherlands: 14,
			SpellingBelgium: 16,
			TaalBelgium: 18,
			getNameByValue: function (value) {
				var self = this;
				var props = Object.getOwnPropertyNames(self);
				for (var i = 0; i < props.length; i++) {
					if (self[props[i]] === value) { return props[i]; }
				}
				return null;
			},
			getLocalizedName: function (subjectCategoryValue) {
				if (subjectCategoryValue) {
					var subjectCategoryName = this.getNameByValue(subjectCategoryValue);
					return Strings['SubjectCategory' + subjectCategoryName];
				}
				return '';
			}
		},

		learningObjectivesProgressTableViewModelMode: {
			'class': 0,
			'pupil': 1
		},

		surveyQuestionType: {
			multipleChoices: 1,
			freeText: 2,
			courses: 3,
			smileySelectorRequired: 4,
			smileySelectorOptional: 5,
			wayOfWorking: 6
		},

		educationPlanSaveMode: {
			Attach: 0,
			Replace: 1,
			Overwrite: 2
		},

		educationPlanViewMode:
		{
			ReadOnlyView: 'ReadOnlyView',
			EditView: 'EditView',
			BookView: 'BookView',
			PupilProgressView: 'PupilProgressView',
			NoPlanExistsView: 'NoEducationPlanView'
		},

		educationPlanLoModalType:
		{
			Finished: 0,
			Stuck: 1,
			InProgress: 2
		},

		educationPlanZoomMode:
		{
			DetailView: 'detail-view',
			CompressedView: 'compressed-view',
			FullView: 'full-view'
		},

		didacticAgeEquivalentMode:
		{
			NotFound: 0,
			WithinMargins: 1,
			BelowMargins: 2,
			AboveMargins: 3
		},

		semesterPeriod:
		{
			year: 0,
			firstSemester: 1,
			secondSemester: 2
		},

		legendType: {
			legend5: 5,
			legend4: 4,
			legend3: 3,
			legend2: 2,
			legend1: 1,

			legendLetter5: 'V',
			legendLetter4: 'IV',
			legendLetter3: 'III',
			legendLetter2: 'II',
			legendLetter1: 'I',

			legendNumeral5: 'V',
			legendNumeral4: 'IV',
			legendNumeral3: 'III',
			legendNumeral2: 'II',
			legendNumeral1: 'I',

			getLocalizedName: function (legendType) {
				switch (legendType) {
				case this.legend1:
					return Strings.PercentileLabelFarAbove;
				case this.legend2:
					return Strings.PercentileLabelAbove;
				case this.legend3:
					return Strings.PercentileLabelAverage;
				case this.legend4:
					return Strings.PercentileLabelBelow;
				case this.legend5:
					return Strings.PercentileLabelFarBelow;
				default:
					return '';
				}
			}
		},

		learningObjectiveState: {
			notStarted: 0,
			inProgress: 1,
			finished: 2,
			stuck: 3,
			preliminary: 4,
			preliminaryProgress: 4,

			getSortableValue: function (state) {
				return state === this.notStarted
					? 1
					: state === this.stuck
						? 2
						: state === this.inProgress
							? 3
							: 4;
			},

			convertToAbilityPercentileState: function (loState) {
				switch (loState) {
				case this.notStarted:
					return enums.abilityPercentileState.notStarted;
				case this.preliminary:
					return enums.abilityPercentileState.preliminary;
				case this.inProgress:
					return enums.abilityPercentileState.reliable;
				case this.finished:
					return enums.abilityPercentileState.reliable;
				case this.stuck:
					return enums.abilityPercentileState.reliable;
				default:
					return enums.abilityPercentileState.notStarted;
				}
			}
		},

		chartLevel: {
			none: '',
			subject: 'subject',
			subdomain: 'sd',
			learningobjective: 'lo',
			allpupils: 'allpupils'
		},

		pupilBackendNames: {
			firstName: 0,
			suffix: 1,
			lastName: 2,
			shortName: 3,
			longName: 4,
			pupilFromAnotherClass: 5,
			actualClassName: 6
		},

		lessonPlanStatus: {
			notWorkedOn: 0,
			workedOn: 1,
			started: 2
		},

		lessonExerciseLabel: {
			start: 0,
			instruction: 1,
			practice: 2,
			extraInstruction: 3
		},

		lessonsTabViewMode:
		{
			StartedLessons: 'started',
			PlannedLessons: 'planned'
		},

		checkViewMode:
		{
			Class: 'class',
			Pupil: 'pupil'
		},

		growthCategories: {
			good: 'good',
			bad: 'bad',
			unknown: 'unknown',

			getProgressCategory: function (progressForLast25Exercises) {
				if (_.isNumber(progressForLast25Exercises)) {
					return progressForLast25Exercises >= 0 ? this.good : this.bad;
				}
				return this.unknown;
			}
		},

		lessonType: {
			Regular: 1,
			Exam: 2,
			Dictation: 3,
			ExtraInstruction: 4
		},

		relevantLessonType: {
			LastLessonSentToClass: 0,
			NextPlannedLesson: 1,
			SuggestedLesson: 2
		},

		progressTimeScope:
		{
			Now: 1,
			Today: 2,
			Yesterday: 3,
			ThisWeek: 4,
			PreviousWeek: 5
		},

		pages: {
			abilityReport: 'AbilityReport',
			workingSet: 'WorkingSet',
			extraInstructions: 'ExtraInstructions',
			growthChart: 'GrowthChart',
			learningObjectives: 'EducationPlan/PupilProgress'
		},

		abilityPercentileState: {
			notStarted: 0,
			preliminary: 1,
			reliable: 2
		},

		bodyClass: {
			home: 'home',
			band: 'band'
		},

		keyCodes: {
			enter: 13
		},

		lessonState: {
			notInLessonPlan: 0,
			inLessonPlanNotInMyLessons: 1,
			inMyLessons: 2
		},
		courseType: {
			none: 0,
			a_ShortenedMethod: 1,
			b_MethodIndependant: 2,
			c_TraditionalMethod: 3,
			d_Other: 4
		},
		suggestionType: {
			none: 0,
			course: 1,
			educationplan: 2
		},
		wayOfWorking: {
			one: 1,
			two: 2,
			three: 3,
			four: 4
		},
		courseStep: {
			Step0: 0,
			Step1: 1,
			Step2: 2,
			Step3: 3
		},

		educationPlanOrigin: {
			Template: 0,
			CreatedFromTemplate: 1,
			Custom: 2
		},

		answerHint: {
			requiredTextEmpty: 1,
			noClickOptionSelected: 2,
			incorrectWithStrictSpelling: 3
		},

		classSubjectGrowthCalculationError: {
			none: 'none',
			noDetail: 'noDetail',
			noPupilsWithGrowth: 'noPupilsWithGrowth',
			noClassGrowthBoundaries: 'noClassGrowthBoundaries',
			noPupilsInAGradeWithBoundaries: 'noPupilsInAGradeWithBoundaries'
		},

		readSpeakerSpeed: {
			Slow: 0,
			Normal: 1,
			Fast: 2
		},
		PasswordValidationType: {
			Default: 1,
			Simple: 2
		}
	};

	return enums;
});

